module.exports = __webpack_public_path__ + "static/design_preview_mobile-db8da5d16a8560789ab5c202d354cfd7.png";